module.exports = __webpack_public_path__ + "img/mrimg1.2f26d525.png";